<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" title="Dips and Spreads">
<div class="titlepage">
<div>
<div>
<h1 class="title"><a id="d0e97" xmlns:saxon="http://icl.com/saxon">Dips and
                            Spreads </a></h1><a id="d0e97" xmlns:saxon="http://icl.com/saxon">
</a></div><a id="d0e97" xmlns:saxon="http://icl.com/saxon">
</a></div><a id="d0e97" xmlns:saxon="http://icl.com/saxon">
</a></div><a id="d0e97" xmlns:saxon="http://icl.com/saxon">
</a><h2 class="nodivide"><a id="d0e97" xmlns:saxon="http://icl.com/saxon"></a><a id="d0e100" xmlns:saxon="http://icl.com/saxon">The Ultimate Spinach Artichoke
                Dip </a></h2><a id="d0e100" xmlns:saxon="http://icl.com/saxon">
<p>
<span class="emphasis">
<em>Makes 4 cups </em>
</span>
</p>
<table border="0" class="simplelist" summary="Simple list">
<tbody><tr>
<td>3 green onions, thinly sliced </td>
</tr>
<tr>
<td>1 tablespoon unsalted butter </td>
</tr>
<tr>
<td>3 cloves garlic, minced </td>
</tr>
<tr>
<td>1 (10-ounce) box frozen chopped spinach, thawed and squeezed dry </td>
</tr>
<tr>
<td>1 (12-ounce) jar artichoke hearts, drained and diced </td>
</tr>
<tr>
<td>8 ounces cream cheese, softened </td>
</tr>
<tr>
<td>1 teaspoon cayenne pepper sauce </td>
</tr>
<tr>
<td>1/2 teaspoon nutmeg </td>
</tr>
<tr>
<td>1/2 cup grated Parmesan cheese </td>
</tr>
<tr>
<td>1/2 cup grated mozzarella cheese </td>
</tr>
</tbody></table>
<p>Preheat oven to 425 degrees. </p>
<p>In a large frying pan, saute onions in butter over medium-high heat until softened
                slightly, about 3 minutes. Add garlic and remove from heat. </p>
<p>Add spinach, artichokes, cream cheese, pepper, nutmeg, and Parmesan to onion mixture
                and spread into an oiled 8 x 8-inch casserole dish or 8-inch pie pan. Sprinkle
                mozzarella on top. </p>
<p>Bake on the top shelf of oven for 25 to 30 minutes, until lightly browned and bubbly.
                Serve immediately with toasted bread slices or crackers. </p>
</a><h2><a id="d0e100" xmlns:saxon="http://icl.com/saxon"></a><a id="d0e136" xmlns:saxon="http://icl.com/saxon">Rustic Cheese Spread </a></h2><a id="d0e136" xmlns:saxon="http://icl.com/saxon">
<p>
<span class="emphasis">
<em>Makes 3 cups </em>
</span>
</p>
<table border="0" class="simplelist" summary="Simple list">
<tbody><tr>
<td>16 ounces assorted bits of cheese, such as cheddar, Gruyere, or Parmesan
                    </td>
</tr>
<tr>
<td>1/2 cup ricotta cheese </td>
</tr>
<tr>
<td>2 tablespoons cream cheese, softened </td>
</tr>
<tr>
<td>1 clove garlic </td>
</tr>
<tr>
<td>2 tablespoons diced flat leaf parsley </td>
</tr>
<tr>
<td>1 tablespoon white wine vinegar </td>
</tr>
<tr>
<td>Dash cayenne pepper sauce, to taste </td>
</tr>
<tr>
<td>Salt and pepper, to taste </td>
</tr>
<tr>
<td>1/4 to 1/2 cup of water </td>
</tr>
</tbody></table>
<p>Place all ingredients except water in food processor and process for about 2 minutes,
                or until very smooth. Add water a few tablespoons at a time, until a smooth and
                spreadable consistency results. </p>
<p>Serve at room temperature with assorted crackers or toasted bread slices. </p>
</a><h2><a id="d0e136" xmlns:saxon="http://icl.com/saxon"></a><a id="d0e166" xmlns:saxon="http://icl.com/saxon">Roasted Garlic Hummus </a></h2><a id="d0e166" xmlns:saxon="http://icl.com/saxon">
<p>
<span class="emphasis">
<em>Makes 3 cups </em>
</span>
</p>
<table border="0" class="simplelist" summary="Simple list">
<tbody><tr>
<td>1 bulb garlic </td>
</tr>
<tr>
<td>3 tablespoons extra virgin olive oil, divided </td>
</tr>
<tr>
<td>2 teaspoons kosher salt, divided </td>
</tr>
<tr>
<td>2 tablespoons lemon juice </td>
</tr>
<tr>
<td>2 (15-ounce) cans garbanzo beans, drained </td>
</tr>
<tr>
<td>1 teaspoon regular or smoked paprika </td>
</tr>
<tr>
<td>Dash cayenne pepper sauce, to taste </td>
</tr>
<tr>
<td>Water as needed for texture</td>
</tr>
</tbody></table>
<p>Preheat oven to 350 degrees. </p>
<p>Cut the bulb of garlic in half across diameter. Place each cut side up in a square of
                aluminum foil. </p>
<p>Drizzle each half with a little oil and sprinkle salt on top. Wrap the foil around
                the bulb halves. Bake for 30 minutes. Remove from oven, bring to room temperature,
                and then squeeze the cloves out of the bulb into a food processor. </p>
<p>Add remaining ingredients, except water, to the garlic and give it a few pulses. Turn
                food processor on and slowly add water in a thin stream until desired consistency. </p>
<p>Serve at room temperature with crackers or toasted baguette slices. </p>
</a><h2><a id="d0e166" xmlns:saxon="http://icl.com/saxon"></a><a id="d0e200" xmlns:saxon="http://icl.com/saxon">Caramelized Onion Dip </a></h2><a id="d0e200" xmlns:saxon="http://icl.com/saxon">
<p>
<span class="emphasis">
<em>Makes 3 cups </em>
</span>
</p>
<table border="0" class="simplelist" summary="Simple list">
<tbody><tr>
<td>3 large yellow onions </td>
</tr>
<tr>
<td>2 tablespoons canola oil </td>
</tr>
<tr>
<td>1/2 tablespoon brown sugar </td>
</tr>
<tr>
<td>1 cup light sour cream </td>
</tr>
<tr>
<td>2 tablespoons mayonnaise </td>
</tr>
<tr>
<td>2 teaspoons Worcestershire sauce </td>
</tr>
<tr>
<td>Salt and pepper, to taste</td>
</tr>
</tbody></table>
<p>Peel onions, cut in half across diameter and slice in 1/4-inch julienne slices. Heat
                oil in large frying pan, add onions and brown sugar and cook over medium-high heat
                for about 30 minutes, stirring frequently to reduce liquid, until onions are well
                browned. Remove from heat and let cool to room temperature. </p>
<p>Place cooked onions in a medium bowl and stir in sour cream, mayonnaise, and
                Worcestershire sauce. Chill for at least 1 hour in refrigerator. Remove and add salt
                and pepper. Serve with chips. </p>
</a><h2><a id="d0e200" xmlns:saxon="http://icl.com/saxon"></a><a id="d0e226" xmlns:saxon="http://icl.com/saxon">Savory Lemon Herb Cheesecake </a></h2><a id="d0e226" xmlns:saxon="http://icl.com/saxon">
<p>
<span class="emphasis">
<em>Makes 6 to 8 servings </em>
</span>
</p>
<table border="0" class="simplelist" summary="Simple list">
<tbody><tr>
<td>1 cup crushed club crackers (about 20 crackers) </td>
</tr>
<tr>
<td>2 tablespoons unsalted butter, melted </td>
</tr>
<tr>
<td>8 ounces cream cheese, softened </td>
</tr>
<tr>
<td>1/2 cup low fat sour cream </td>
</tr>
<tr>
<td>1/2 cup finely grated Parmesan cheese </td>
</tr>
<tr>
<td>3 eggs </td>
</tr>
<tr>
<td>2 tablespoons cornstarch </td>
</tr>
<tr>
<td>1/4 cup minced fresh herbs, such as parsley, thyme, rosemary </td>
</tr>
<tr>
<td>Zest and juice of 1 lemon </td>
</tr>
<tr>
<td>1 teaspoon garlic powder </td>
</tr>
</tbody></table>
<p>Preheat oven to 350 degrees. </p>
<p>In a small bowl, stir together the cracker crumbs and butter. Press into the bottom
                of an 8-inch spring form pan. Bake 8 to 10 minutes, until crust is set and lightly
                browned. </p>
<p>In a medium bowl, using a mixer on medium speed, beat together remaining ingredients
                until well blended. Pour on top of crust. Cover bottom and up the outside of pan
                with aluminum foil. Place pan in the center of a large roasting pan and add hot
                water, filling halfway up sides of spring form pan. Bake for 30 minutes. Reduce oven
                heat to 325 degrees and bake another 15 to 20 minutes, until almost set in center. </p>
<p>Turn off oven and let cheesecake remain in oven until room temperature. Serve at room
                temperature with crackers for spreading. </p>
</a><h2><a id="d0e226" xmlns:saxon="http://icl.com/saxon"></a><a id="d0e262" xmlns:saxon="http://icl.com/saxon">Gorgonzola Fruit Dip </a></h2><a id="d0e262" xmlns:saxon="http://icl.com/saxon">
<p>
<span class="emphasis">
<em>Makes 2 cups </em>
</span>
</p>
<table border="0" class="simplelist" summary="Simple list">
<tbody><tr>
<td>8 ounces cream cheese, softened </td>
</tr>
<tr>
<td>1/4 cup light corn syrup </td>
</tr>
<tr>
<td>1 tablespoon lemon juice </td>
</tr>
<tr>
<td>1 teaspoon lemon zest </td>
</tr>
<tr>
<td>1/4 teaspoon ground ginger </td>
</tr>
<tr>
<td>1/2 cup crumbled Gorgonzola cheese </td>
</tr>
<tr>
<td>3 ripe but firm pears </td>
</tr>
<tr>
<td>2 apples</td>
</tr>
</tbody></table>
<p>In a small bowl, stir together the cream cheese, corn syrup, lemon juice, zest, and
                ginger. Gently stir in Gorgonzola so there are still some crumbles intact. Cover and
                chill for 1 hour. </p>
<p>Core pears and apples and cut into 1/4-inch thick slices. Serve chilled dip with
                fruit. </p>
</a><h2><a id="d0e262" xmlns:saxon="http://icl.com/saxon"></a><a id="d0e290" xmlns:saxon="http://icl.com/saxon">Roasted Red Pepper Dip </a></h2><a id="d0e290" xmlns:saxon="http://icl.com/saxon">
<p>
<span class="emphasis">
<em>Makes 3 cups </em>
</span>
</p>
<table border="0" class="simplelist" summary="Simple list">
<tbody><tr>
<td>1 red bell pepper, seeds removed, and cut into 1-inch strips </td>
</tr>
<tr>
<td>Canola oil spray </td>
</tr>
<tr>
<td>3 cloves garlic, minced </td>
</tr>
<tr>
<td>16 ounces ricotta cheese </td>
</tr>
<tr>
<td>1 tablespoon balsamic vinegar</td>
</tr>
</tbody></table>
<p>Place peppers on a baking sheet and lightly spray with oil. Broil about 6 inches from
                heat for 5 minutes. Sprinkle garlic over peppers and broil another 2 minutes, until
                peppers are lightly browned. </p>
<p>Place peppers and garlic in food processor with ricotta and vinegar. Pulse until
                peppers are in very small bits. </p>
<p>Serve at room temperature with crackers or vegetables. </p>
</a><h2><a id="d0e290" xmlns:saxon="http://icl.com/saxon"></a><a id="d0e314" xmlns:saxon="http://icl.com/saxon">White Bean and Spinach Dip </a></h2><a id="d0e314" xmlns:saxon="http://icl.com/saxon">
<p>
<span class="emphasis">
<em>Makes 3 cups </em>
</span>
</p>
<table border="0" class="simplelist" summary="Simple list">
<tbody><tr>
<td>1 (10-ounce) package frozen chopped spinach, thawed and squeezed dry </td>
</tr>
<tr>
<td>2 tablespoons canola oil </td>
</tr>
<tr>
<td>3 cloves garlic, minced </td>
</tr>
<tr>
<td>2 (15-ounce) cans cannellini or white beans, drained </td>
</tr>
<tr>
<td>Juice of 1 lemon (about 2 tablespoons) </td>
</tr>
<tr>
<td>1 tablespoon balsamic vinegar </td>
</tr>
<tr>
<td>Dash cayenne pepper sauce, to taste </td>
</tr>
<tr>
<td>Salt and pepper, to taste </td>
</tr>
</tbody></table>
<p>In a large frying pan, saute spinach in oil for about 3 minutes, until little liquid
                remains. Stir in garlic and saute another 1 to 2 minutes, until garlic becomes
                fragrant. </p>
<p>Remove from heat and add beans, lemon juice, vinegar, and pepper sauce. Mash with a
                potato masher until well blended. Add salt and pepper. </p>
<p>Serve at room temperature with crackers, pita chips, or toasted baguette slices. </p>
</a><h2><a id="d0e314" xmlns:saxon="http://icl.com/saxon"></a><a id="d0e344" xmlns:saxon="http://icl.com/saxon">Pizza Fondue </a></h2><a id="d0e344" xmlns:saxon="http://icl.com/saxon">
<p>
<span class="emphasis">
<em>Makes 4 cups </em>
</span>
</p>
<table border="0" class="simplelist" summary="Simple list">
<tbody><tr>
<td>1 large yellow onion, diced </td>
</tr>
<tr>
<td>1 green bell pepper, diced </td>
</tr>
<tr>
<td>2 tablespoons canola oil </td>
</tr>
<tr>
<td>3 cloves garlic, minced </td>
</tr>
<tr>
<td>1 tablespoon cornstarch </td>
</tr>
<tr>
<td>1 cup pizza sauce </td>
</tr>
<tr>
<td>1/2 cup finely grated Parmesan cheese </td>
</tr>
<tr>
<td>8 ounces cream cheese </td>
</tr>
<tr>
<td>12 slices low fat turkey pepperoni, minced </td>
</tr>
<tr>
<td>1 loaf French bread </td>
</tr>
<tr>
<td>Canola oil spray </td>
</tr>
<tr>
<td>1 teaspoon garlic powder </td>
</tr>
</tbody></table>
<p>In a large frying pan, saute onion and bell pepper in oil over medium heat until
                softened, about 5 minutes. Stir in garlic and cornstarch until cornstarch is
                absorbed. </p>
<p>Add pizza sauce, Parmesan, cream cheese, and pepperoni to frying pan and bring to a
                simmer for about 5 minutes. (At this point, sauce can be served as is, or it can be
                blended until smooth and then served.) </p>
<p>Cut bread into 1-inch cubes and spread on a baking sheet in a single layer. Lightly
                spray with oil. Broil about 6 inches from heat for 1 to 2 minutes, until lightly
                toasted, watching closely so it doesn’t burn. Turn bread over, lightly spray with
                oil and broil on other side. While bread cubes are still hot, sprinkle with garlic
                powder and toss. </p>
<p>Serve warm sauce with bread cubes spread for dipping. </p>
</a><h2><a id="d0e344" xmlns:saxon="http://icl.com/saxon"></a><a id="d0e384" xmlns:saxon="http://icl.com/saxon">Roasted Veggie Spread </a></h2><a id="d0e384" xmlns:saxon="http://icl.com/saxon">
<p>
<span class="emphasis">
<em>Makes 4 cups </em>
</span>
</p>
<table border="0" class="simplelist" summary="Simple list">
<tbody><tr>
<td>1 medium eggplant, stem removed </td>
</tr>
<tr>
<td>1 yellow onion, peeled </td>
</tr>
<tr>
<td>Canola oil spray </td>
</tr>
<tr>
<td>1 green bell pepper, seeds and pulp removed </td>
</tr>
<tr>
<td>1 red bell pepper, seeds and pulp removed </td>
</tr>
<tr>
<td>3 cloves garlic, peeled </td>
</tr>
<tr>
<td>1/4 cup extra virgin olive oil </td>
</tr>
<tr>
<td>1/2 cup ricotta cheese </td>
</tr>
<tr>
<td>Salt and pepper, to taste </td>
</tr>
</tbody></table>
<p>Cut eggplant into 1/4-inch-thick slices. Cut onion in half across diameter and then
                into 1/4-inch slices. Place eggplant and onion slices on a lightly oiled baking
                sheet and spray with oil. Broil about 6 inches from heat for about 5 minutes,
                watching closely so it doesn’t burn, until softened and lightly browned. Turn
                eggplant and onion over, lightly spray with oil and broil another 3 minutes. </p>
<p>Slice peppers into 1-inch strips and place on a lightly oiled baking sheet; add
                garlic cloves and spray lightly with oil. Broil about 6 inches from heat for about 5
                minutes, watching closely so it doesn’t burn, until softened and lightly browned. </p>
<p>Place vegetables in a food processor with olive oil, ricotta cheese, salt and pepper,
                and pulse until vegetables are in small bits, but not pureed. </p>
<p>Serve at room temperature with crackers. </p>
</a><h2><a id="d0e384" xmlns:saxon="http://icl.com/saxon"></a><a id="d0e418" xmlns:saxon="http://icl.com/saxon">Cowboy Caviar </a></h2><a id="d0e418" xmlns:saxon="http://icl.com/saxon">
<p>
<span class="emphasis">
<em>Makes 4 cups </em>
</span>
</p>
<table border="0" class="simplelist" summary="Simple list">
<tbody><tr>
<td>1 (15-ounce) can hominy, drained and rinsed </td>
</tr>
<tr>
<td>1 (15-ounce) can black-eyed peas, drained and rinsed </td>
</tr>
<tr>
<td>1 (15-ounce) can black beans, drained and rinsed </td>
</tr>
<tr>
<td>2 Roma tomatoes, diced </td>
</tr>
<tr>
<td>1 avocado, diced </td>
</tr>
<tr>
<td>1/4 cup diced cilantro </td>
</tr>
<tr>
<td>1/4 cup extra virgin olive oil </td>
</tr>
<tr>
<td>2 tablespoons red wine vinegar </td>
</tr>
<tr>
<td>1/2 teaspoon garlic powder </td>
</tr>
<tr>
<td>Salt, to taste </td>
</tr>
<tr>
<td>Dash cayenne pepper sauce, to taste </td>
</tr>
</tbody></table>
<p>In a medium bowl, toss together hominy, black-eyed peas, beans, tomato, avocado, and
                cilantro. </p>
<p>In a small bowl, whisk together the remaining ingredients, tasting as you add salt
                and pepper sauce. Pour over bean mixture and mix well. </p>
<p>Serve at room temperature with chips, bagel crisps, or toasted baguette slices. </p>
</a><h2><a id="d0e418" xmlns:saxon="http://icl.com/saxon"></a><a id="d0e454" xmlns:saxon="http://icl.com/saxon">Lemon Garlic White Bean Dip </a></h2><a id="d0e454" xmlns:saxon="http://icl.com/saxon">
<p>
<span class="emphasis">
<em>Makes 3 cups </em>
</span>
</p>
<table border="0" class="simplelist" summary="Simple list">
<tbody><tr>
<td>2 (15-ounce) cans cannellini beans, drained and rinsed </td>
</tr>
<tr>
<td>1 clove garlic </td>
</tr>
<tr>
<td>1 teaspoon lemon zest </td>
</tr>
<tr>
<td>2 tablespoons lemon juice </td>
</tr>
<tr>
<td>1/2 cup extra virgin olive oil </td>
</tr>
<tr>
<td>1 (2-ounce) jar diced pimiento </td>
</tr>
<tr>
<td>2 tablespoons minced parsley leaves </td>
</tr>
<tr>
<td>Salt and pepper, to taste </td>
</tr>
</tbody></table>
<p>In a food processor combine beans, garlic, zest, lemon juice, and oil, and blend
                until very smooth. Place in a small bowl and stir in pimientos, parsley, salt, and
                pepper. </p>
<p>Serve at room temperature with pita crisps, tortilla chips, or crackers. </p>
</a><h2><a id="d0e454" xmlns:saxon="http://icl.com/saxon"></a><a id="d0e482" xmlns:saxon="http://icl.com/saxon">Layered Pesto Torte </a></h2><a id="d0e482" xmlns:saxon="http://icl.com/saxon">
<p>
<span class="emphasis">
<em>Makes 8 to 10 servings </em>
</span>
</p>
<table border="0" class="simplelist" summary="Simple list">
<tbody><tr>
<td>1 shallot, peeled and diced </td>
</tr>
<tr>
<td>1 tablespoon butter </td>
</tr>
<tr>
<td>2 sun-dried tomatoes, diced </td>
</tr>
<tr>
<td>16 ounces cream cheese, softened and divided </td>
</tr>
<tr>
<td>1/2 cup finely grated Parmesan cheese </td>
</tr>
<tr>
<td>1/2 teaspoon garlic powder </td>
</tr>
<tr>
<td>1/3 cup basil pesto</td>
</tr>
</tbody></table>
<p>In a small frying pan, saute shallot in butter over medium-high heat until softened.
                Place in a food processor along with tomatoes and 2 tablespoons cream cheese and
                pulse until roughly chopped. </p>
<p>Line a deep 2-cup capacity bowl with plastic wrap and spray with nonstick cooking
                spray. Spoon tomato mixture into bottom of bowl and level it out. </p>
<p>In a small bowl, stir together remaining cream cheese, Parmesan, and garlic powder.
                Spoon half of cream cheese mixture into bowl over tomato mixture, leveling the cream
                cheese mixture. Spread pesto over top of cream cheese layer. Spread the remaining
                cream cheese mixture over top of pesto, leveling mixture. </p>
<p>Chill for at least 2 hours, or up to 24 hours. Invert onto a serving plate and remove
                plastic. </p>
<p>Serve with crackers. </p>
</a><h2><a id="d0e482" xmlns:saxon="http://icl.com/saxon"></a><a id="d0e514" xmlns:saxon="http://icl.com/saxon">Buffalo Style Layered Spread </a></h2><a id="d0e514" xmlns:saxon="http://icl.com/saxon">
<p>
<span class="emphasis">
<em>Makes 4 cups </em>
</span>
</p>
<table border="0" class="simplelist" summary="Simple list">
<tbody><tr>
<td>16 ounces cream cheese, softened </td>
</tr>
<tr>
<td>1 cup shredded cooked chicken </td>
</tr>
<tr>
<td>1 tablespoon cayenne pepper sauce </td>
</tr>
<tr>
<td>1/2 red bell pepper, diced </td>
</tr>
<tr>
<td>1/2 cup diced celery </td>
</tr>
<tr>
<td>1/2 cup crumbled blue cheese</td>
</tr>
</tbody></table>
<p>Spread cream cheese on bottom of an 8-inch pie pan or serving plate. Toss chicken
                with pepper sauce and layer over cream cheese. Top with bell pepper and celery. </p>
<p>Cook in microwave on high until heated through, about 2 to 3 minutes. </p>
<p>Top with blue cheese. Serve with celery sticks. </p>
</a><h2><a id="d0e514" xmlns:saxon="http://icl.com/saxon"></a><a id="d0e540" xmlns:saxon="http://icl.com/saxon">Nutty Olive Spread </a></h2><a id="d0e540" xmlns:saxon="http://icl.com/saxon">
<p>
<span class="emphasis">
<em>Makes 3 cups </em>
</span>
</p>
<table border="0" class="simplelist" summary="Simple list">
<tbody><tr>
<td>1 cup diced hazelnuts </td>
</tr>
<tr>
<td>2 garlic cloves, pressed </td>
</tr>
<tr>
<td>1 tablespoon extra virgin olive oil </td>
</tr>
<tr>
<td>1 cup stuffed green olives </td>
</tr>
<tr>
<td>1 cup ricotta cheese </td>
</tr>
<tr>
<td>8 ounces light cream cheese, softened</td>
</tr>
</tbody></table>
<p>Preheat oven to 350 degrees. </p>
<p>Spread hazelnuts on a baking sheet and bake for 15 minutes. </p>
<p>Process remaining ingredients in pulses in food processor until olives are in small
                pieces, but are not pureed. Stir nuts into mixture. </p>
<p>Serve at room temperature with crackers for spreading. </p>
</a><h2><a id="d0e540" xmlns:saxon="http://icl.com/saxon"></a><a id="d0e568" xmlns:saxon="http://icl.com/saxon">Pineapple Cheddar Spread </a></h2><a id="d0e568" xmlns:saxon="http://icl.com/saxon">
<p>
<span class="emphasis">
<em>Makes 6 cups </em>
</span>
</p>
<table border="0" class="simplelist" summary="Simple list">
<tbody><tr>
<td>1 (8-ounce) can crushed pineapple, drained </td>
</tr>
<tr>
<td>8 ounces cream cheese, softened </td>
</tr>
<tr>
<td>4 cups grated sharp cheddar cheese </td>
</tr>
<tr>
<td>1/2 cup mayonnaise </td>
</tr>
<tr>
<td>2 teaspoons soy sauce </td>
</tr>
<tr>
<td>1 cup diced, smoked, or toasted almonds </td>
</tr>
<tr>
<td>1/2 green bell pepper, diced </td>
</tr>
<tr>
<td>2 green onions, thinly sliced </td>
</tr>
</tbody></table>
<p>In a large bowl, mix together all ingredients until well combined. Cover and
                refrigerate until chilled, at least 1 hour, or up to 24 hours. </p>
<p>Serve chilled with large crackers or toasted baguette slices. </p>
</a><h2><a id="d0e568" xmlns:saxon="http://icl.com/saxon"></a><a id="d0e596" xmlns:saxon="http://icl.com/saxon">Three Step Pate </a></h2><a id="d0e596" xmlns:saxon="http://icl.com/saxon">
<p>
<span class="emphasis">
<em>Makes 2 cups </em>
</span>
</p>
<table border="0" class="simplelist" summary="Simple list">
<tbody><tr>
<td>2 tablespoons unsalted butter </td>
</tr>
<tr>
<td>1 medium yellow onion, diced </td>
</tr>
<tr>
<td>1 pound chicken livers, cleaned and patted dry </td>
</tr>
<tr>
<td>1/4 cup chicken broth </td>
</tr>
<tr>
<td>1 tablespoon white wine vinegar </td>
</tr>
<tr>
<td>2 hard boiled eggs, peeled and rough chopped </td>
</tr>
<tr>
<td>1 teaspoon cayenne pepper sauce </td>
</tr>
<tr>
<td>Salt and pepper, to taste</td>
</tr>
</tbody></table>
<p>In a large frying pan add butter and onion and cook over medium-high heat until
                softened, about 5 minutes, stirring frequently. Cut chicken livers in half and add
                to pan. Cook until no longer pink in center. Remove chicken livers and onions from
                pan and set aside. </p>
<p>Add broth and vinegar to frying pan and scrape up all brown bits from bottom. Turn
                off heat and let cool. Add all ingredients to food processor and pulse until
                everything is in very small bits. Place in a serving bowl, cover and refrigerate for
                at least 1 hour, until chilled. </p>
<p>Serve with toasted baguette slices or artisan style crackers. </p>
</a><h2><a id="d0e596" xmlns:saxon="http://icl.com/saxon"></a><a id="d0e626" xmlns:saxon="http://icl.com/saxon">Pesto Warm Goat Cheese Spread </a></h2><a id="d0e626" xmlns:saxon="http://icl.com/saxon">
<p>
<span class="emphasis">
<em>Makes 2 cups </em>
</span>
</p>
<table border="0" class="simplelist" summary="Simple list">
<tbody><tr>
<td>1 cup pine nuts, divided </td>
</tr>
<tr>
<td>2 cups basil leaves </td>
</tr>
<tr>
<td>2 cloves garlic </td>
</tr>
<tr>
<td>1/2 cup grated Parmesan cheese </td>
</tr>
<tr>
<td>1/3 cup extra virgin olive oil, divided </td>
</tr>
<tr>
<td>10 to 12 ounces goat cheese, at room temperature </td>
</tr>
<tr>
<td>Salt and pepper, to taste</td>
</tr>
</tbody></table>
<p>In a large frying pan toast pine nuts over medium heat until lightly browned,
                stirring frequently, about 3 minutes. </p>
<p>In a food processor pulse, 1/2 cup pine nuts, basil, Parmesan, and garlic until very
                small bits. While processor is on, pour in 1/4 cup of oil, and continue until well
                blended. </p>
<p>In a small bowl, mix goat cheese with remaining oil, salt, and pepper. Spread goat
                cheese on a microwave-safe salad plate, to 1/2-inch thick. Microwave until hot,
                about 90 seconds. </p>
<p>Spread basil pesto on top of goat cheese, leaving 1/2-inch around edge. Sprinkle with
                remaining pine nuts. </p>
<p>Serve with crackers, toasted bread slices, or pita crisp triangles. </p>
</a><h2><a id="d0e626" xmlns:saxon="http://icl.com/saxon"></a><a id="d0e658" xmlns:saxon="http://icl.com/saxon">Shrimp Topped Avocado Mousse </a></h2><a id="d0e658" xmlns:saxon="http://icl.com/saxon">
<p>
<span class="emphasis">
<em>Makes 8 to 10 servings </em>
</span>
</p>
<table border="0" class="simplelist" summary="Simple list">
<tbody><tr>
<td>1/4 cup cold water </td>
</tr>
<tr>
<td>1 envelope (1 tablespoon) unflavored gelatin </td>
</tr>
<tr>
<td>1 cup mashed avocado (2 to 3 avocados) </td>
</tr>
<tr>
<td>1 tablespoon lime juice </td>
</tr>
<tr>
<td>1/2 teaspoon guacamole seasoning mix </td>
</tr>
<tr>
<td>2 cups sour cream </td>
</tr>
<tr>
<td>3 tablespoons chopped cilantro </td>
</tr>
<tr>
<td>Dash Tabasco Sauce, to taste </td>
</tr>
<tr>
<td>2 to 3 drops green food coloring, if desired </td>
</tr>
<tr>
<td>1 pound cooked, chilled small salad shrimp </td>
</tr>
<tr>
<td>Diced green onions, mango, or peppers, as desired for garnish </td>
</tr>
</tbody></table>
<p>Lightly oil a 9-inch pie plate or tart pan. Pour water into a small saucepan and
                sprinkle with gelatin. Let soften for 5 minutes. Slowly heat mixture until gelatin
                is dissolved. </p>
<p>Blend avocados, lime juice, guacamole seasoning, sour cream, cilantro, and Tabasco
                Sauce in a food processor. Add gelatin mixture and blend well. Add food coloring and
                pour into the pie plate. Cover with plastic wrap making sure the plastic covers
                surface of the dip. Refrigerate until set. </p>
<p>When ready to serve, unmold the avocado mousse from plate onto a serving tray by
                dipping the bottom of the plate in warm water and running a knife around the edge of
                the pan. Toss shrimp with desired garnishes and arrange evenly around the top of the
                dip. Serve with tortilla chips or crackers. </p>
</a><h2><a id="d0e658" xmlns:saxon="http://icl.com/saxon"></a><a id="d0e694" xmlns:saxon="http://icl.com/saxon">Clams Casino Dip </a></h2><a id="d0e694" xmlns:saxon="http://icl.com/saxon">
<p>
<span class="emphasis">
<em>Makes 4 cups </em>
</span>
</p>
<table border="0" class="simplelist" summary="Simple list">
<tbody><tr>
<td>4 slices bacon, diced </td>
</tr>
<tr>
<td>2 tablespoons minced shallots </td>
</tr>
<tr>
<td>1 clove garlic, minced </td>
</tr>
<tr>
<td>3 (6-1/2-ounce) cans minced clams </td>
</tr>
<tr>
<td>16 ounces cream cheese, cubed </td>
</tr>
<tr>
<td>1 tablespoon oregano </td>
</tr>
<tr>
<td>2 teaspoons lemon juice </td>
</tr>
<tr>
<td>2 teaspoons Worcestershire sauce </td>
</tr>
<tr>
<td>1/2 teaspoon salt </td>
</tr>
<tr>
<td>6 drops Tabasco Sauce </td>
</tr>
<tr>
<td>1/2 cup fresh breadcrumbs </td>
</tr>
<tr>
<td>2 tablespoons butter, melted </td>
</tr>
</tbody></table>
<p>Preheat oven to 350 degrees. </p>
<p>In a small frying pan cook bacon until crispy. Remove from pan and drain most of the
                bacon fat. Add shallots to pan and saute for 2 minutes. Add garlic and saute until
                soft. Add shallots and garlic to the bacon. </p>
<p>Drain 2 cans of clams, discarding juices. Drain remaining can, reserving the juice.
                In a food processor, combine the clams, cream cheese, oregano, lemon juice,
                Worcestershire sauce, salt, Tabasco, bacon mixture, and reserved clam juice; cover
                and process until smooth. </p>
<p>Mix melted butter into breadcrumbs. </p>
<p>Place dip in an oven-proof serving dish and top with breadcrumbs. Bake for 40
                minutes, or until bubbly and breadcrumbs are golden brown. </p>
</a><h2><a id="d0e694" xmlns:saxon="http://icl.com/saxon"></a><a id="d0e736" xmlns:saxon="http://icl.com/saxon">Spanish Fig and Almond Bites </a></h2><a id="d0e736" xmlns:saxon="http://icl.com/saxon">
<p>
<span class="emphasis">
<em>Makes 10 </em>
</span>
</p>
<table border="0" class="simplelist" summary="Simple list">
<tbody><tr>
<td>1/2 cup whole almonds, toasted </td>
</tr>
<tr>
<td>2-1/4 cups dried whole figs, hard stalk and center of base removed </td>
</tr>
<tr>
<td>1/3 cup chopped dried apricots </td>
</tr>
<tr>
<td>1/4 cup dried cranberries </td>
</tr>
<tr>
<td>1 tablespoon apple cider </td>
</tr>
<tr>
<td>1 tablespoon honey </td>
</tr>
<tr>
<td>1 teaspoon ground allspice </td>
</tr>
<tr>
<td>10 extra toasted almonds, for garnish </td>
</tr>
</tbody></table>
<p>Blend almonds in a food processor until finely chopped. Pour into a large bowl. Chop
                the figs and process to a smooth, sticky paste in the food processor. Stir fig
                mixture into almonds. Pulse apricots, cranberries, apple cider, honey, and allspice
                in food processor until small bits. Add to fig mixture and mix well. </p>
<p>Divide into 10 small portions and roll into balls. Place one whole almond on each
                ball and press in slightly. </p>
<p>Serve with assorted cheeses and crackers. </p>
</a><h2><a id="d0e736" xmlns:saxon="http://icl.com/saxon"></a><a id="d0e766" xmlns:saxon="http://icl.com/saxon">Red Pepper Tapenade </a></h2><a id="d0e766" xmlns:saxon="http://icl.com/saxon">
<p>
<span class="emphasis">
<em>Makes 3 cups </em>
</span>
</p>
<table border="0" class="simplelist" summary="Simple list">
<tbody><tr>
<td>1/2 cup black, oil-cured olives </td>
</tr>
<tr>
<td>1/2 cup green olives </td>
</tr>
<tr>
<td>2 large cloves garlic, chopped </td>
</tr>
<tr>
<td>2 anchovy filets </td>
</tr>
<tr>
<td>3 tablespoons capers </td>
</tr>
<tr>
<td>1 (16-ounce) jar roasted red peppers </td>
</tr>
<tr>
<td>1 loaf crusty bread </td>
</tr>
</tbody></table>
<p>Remove seeds from olives, if necessary. Place olives, garlic, anchovies, and capers
                in a food processor. Pulse until coarsely chopped. Dice red pepper and fold into
                olive mixture. </p>
<p>Serve with crusty bread cut into large cubes. </p>
</a><h2><a id="d0e766" xmlns:saxon="http://icl.com/saxon"></a><a id="d0e792" xmlns:saxon="http://icl.com/saxon">Bombay Red Lentil Dip </a></h2><a id="d0e792" xmlns:saxon="http://icl.com/saxon">
<p>
<span class="emphasis">
<em>Makes 3 cups </em>
</span>
</p>
<table border="0" class="simplelist" summary="Simple list">
<tbody><tr>
<td>1 cup dry red lentils </td>
</tr>
<tr>
<td>1 medium shallot, diced </td>
</tr>
<tr>
<td>1 tablespoon canola oil </td>
</tr>
<tr>
<td>1/3 cup diced toasted cashews </td>
</tr>
<tr>
<td>1/4 cup sour cream </td>
</tr>
<tr>
<td>1 teaspoon salt </td>
</tr>
<tr>
<td>1/2 teaspoon cumin </td>
</tr>
<tr>
<td>1/2 teaspoon coriander </td>
</tr>
<tr>
<td>Dash cayenne pepper sauce, to taste </td>
</tr>
<tr>
<td>1 small tomato, diced</td>
</tr>
</tbody></table>
<p>In a medium saucepan, boil lentils in 2 cups salted water for 8 minutes. Drain,
                reserving liquid. </p>
<p>In a small frying pan over medium-high heat, cook shallot in oil until softened.
                Place lentils, shallots, and remaining ingredients in a food processor, and mix
                adding a little reserved water to make a smooth creamy consistency. </p>
<p>Serve at room temperature. </p>
</a><h2><a id="d0e792" xmlns:saxon="http://icl.com/saxon"></a><a id="d0e826" xmlns:saxon="http://icl.com/saxon">Goat Cheese in Grape Leaves </a></h2><a id="d0e826" xmlns:saxon="http://icl.com/saxon">
<p>
<span class="emphasis">
<em>Makes 6 to 8 servings </em>
</span>
</p>
<table border="0" class="simplelist" summary="Simple list">
<tbody><tr>
<td>2 heads garlic </td>
</tr>
<tr>
<td>4 tablespoons olive oil </td>
</tr>
<tr>
<td>4 to 6 sprigs fresh thyme, divided </td>
</tr>
<tr>
<td>Dash salt and pepper </td>
</tr>
<tr>
<td>8 ounces goat cheese, softened </td>
</tr>
<tr>
<td>4 ounces marinated feta, drained </td>
</tr>
<tr>
<td>2 to 3 teaspoons olive oil </td>
</tr>
<tr>
<td>1 (16-ounce) jar grape leaves packed in water </td>
</tr>
<tr>
<td>2 (6-ounce) jars capers </td>
</tr>
<tr>
<td>1 3-inch diameter French baguette, sliced into rounds</td>
</tr>
</tbody></table>
<p>Preheat oven to 400 degrees. </p>
<p>Cut garlic in half across diameter. Place on aluminum foil and drizzle with olive
                oil. Top with 2 to 3 sprigs of thyme, salt and pepper. Seal foil to make a packet
                and bake for 1 hour. Set aside. </p>
<p>In a small bowl, beat cheeses together for 2 to 3 minutes. Remove leaves from
                remaining sprigs of thyme and chop. Mix into cheese. </p>
<p>Lightly oil a 3 to 4 cup loaf pan. Line pan with grape leaves, extending above edge
                of the pan. Fill pan with 2/3 of the cheese mixture. Spread capers over cheese and
                top with remaining cheese. Fold the leaves over top of the cheese and cover with
                foil. </p>
<p>Reduce oven temperature to 325 degrees. Bake for 15 to 20 minutes. Brush bread with
                olive oil and toast until lightly browned. </p>
<p>Turn cheese out of the loaf pan onto a serving tray. Slice into 1/2-inch thick
                slices. Serve with toasted baguette and roasted garlic. </p>
</a><h2><a id="d0e826" xmlns:saxon="http://icl.com/saxon"></a><a id="d0e866" xmlns:saxon="http://icl.com/saxon">Yucatan Style Seafood Ceviche </a></h2><a id="d0e866" xmlns:saxon="http://icl.com/saxon">
<p>
<span class="emphasis">
<em>Makes 4 cups </em>
</span>
</p>
<table border="0" class="simplelist" summary="Simple list">
<tbody><tr>
<td>8 ounces uncooked small bay scallops </td>
</tr>
<tr>
<td>8 ounces uncooked shrimp, peeled and deveined </td>
</tr>
<tr>
<td>1/2 cup fresh orange juice </td>
</tr>
<tr>
<td>1/2 cup fresh lime juice </td>
</tr>
<tr>
<td>1/2 cup fresh lemon juice </td>
</tr>
<tr>
<td>1 jalapeno, seeded and finely diced </td>
</tr>
<tr>
<td>1/2 red onion, finely diced </td>
</tr>
<tr>
<td>2 tablespoons minced cilantro </td>
</tr>
<tr>
<td>1/2 small jicama, peeled and diced </td>
</tr>
<tr>
<td>1/2 cucumber, peeled, seeded, and diced </td>
</tr>
<tr>
<td>2 oranges, segmented and diced </td>
</tr>
<tr>
<td>Salt and pepper, to taste </td>
</tr>
<tr>
<td>
</td></tr>
</tbody></table>
<p>Fill a large bowl with ice water and set aside. </p>
<p>In a large saucepan, bring 2 quarts of salted water to a boil and cook shrimp and
                scallops for 2 minutes. Do not overcook. Drain immediately and place in ice water to
                stop the cooking. Chop shrimp to same size as scallops. </p>
<p>In a medium bowl, mix orange, lime, and lemon juices with jalapeno, onion, and
                cilantro. Drain seafood, add to mixture, and chill for 30 minutes to 1 hour. </p>
<p>Drain most of the marinade from seafood and toss with jicama, cucumber, and oranges.
                Season with salt and pepper. </p>
<p>Spoon mixture into martini glasses or serve in a large bowl with tortilla chips. If
                desired, garnish with freshly diced avocado and cilantro. </p>
</a></div><a id="d0e866" xmlns:saxon="http://icl.com/saxon">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch02.vue?487fc17c